var navbar = {
	title:"",
	parentDiv:"",
	
	setTitle: function(t) {
		$("#info").html(t);
		navbar.title = t;
	},
	
//	setMenu: function(data, parent, pdiv) {
	setMenu: function(item, data) {
		//navbar.parentDiv = pdiv;
		navbar.item = item;
/*		
		if (parent != null) {
			$("#info").html("<a href='javascript:void(null);' onclick='navbar.openMenu();' class='currentMenuButton'><img src='assets/current_menu.png' width='20' height='20' style='vertical-align:middle;'>" + parent.title + "</a> <img src='assets/right_arrow.png' width='16' height='16' style='vertical-align:middle;'> " + navbar.title);
		}
*/
		if (item.parent != null) {
			var title;
			title = (item != null && item.title != null)?item.title:"";
			if (title.length > 10) title = title.substr(0,10) + " ...";
			if (data != null && data.title != null && navbar.title == "") navbar.title = data.title;
			$("#info").html("<a href='javascript:void(null);' onclick='navbar.openMenu();' class='currentMenuButton'><img src='assets/current_menu.png?20131125' width='12' height='12'><span>" + title + "</span></a> <img src='assets/right_arrow.png' width='16' height='16' style='vertical-align:middle;'> " + navbar.title);
		}
	},
	
	openMenu: function() {
		setTimeout(function() {
			$("#panosback").show();
			$("#panosback a").show();
			$("#menubar").show();
			$("#panos").addClass("visible");
			
			var stateObj = { "current": "inMenu"};
			player.addToHistory(stateObj, "W menu", "#inMenu");
			player.setHistoryManager(player.list);
			
//			console.log(navbar.parentDiv);
			
			player.list.openMenu(navbar.item);
//			player.list.openMenu(navbar.parentDiv);
		}, 100);
	}

}